export default __webpack_public_path__ + "static/image-2-d56bc58cf8a568608eeb7bd22b445cbe.jpg";